import { omit, get, cloneDeep } from 'lodash'
import axios from 'axios'
import WebfontLoader from 'webfontloader'
import { AWS_API, APP_API, CDN_URL, AWS_API_CDN } from '../config'

// Một request cho mỗi URL dù nhiều layer cùng xin (5 layer clipart cùng danh
// mục từng gửi 5 request /categories giống hệt). Mỗi nơi gọi nhận bản parse
// riêng, vì code gọi có sửa trực tiếp dữ liệu trả về. Lỗi thì bỏ khỏi cache để
// lần sau thử lại.
const sharedJsonRequests = {}
export const fetchJsonShared = url => {
  if (!sharedJsonRequests[url]) {
    sharedJsonRequests[url] = fetch(url)
      .then(response => {
        if (!response.ok) throw new Error(`HTTP ${response.status}`)
        return response.text()
      })
      .then(text => {
        JSON.parse(text) // nội dung hỏng thì không giữ lại trong cache
        return text
      })
      .catch(err => {
        delete sharedJsonRequests[url]
        throw err
      })
  }
  return sharedJsonRequests[url].then(text => JSON.parse(text))
}

// export const checkWebp = callback => {
//   var webP = new Image()
//   webP.onload = webP.onerror = function() {
//     callback(webP.height === 2)
//   }
//   webP.src =
//     'data:image/webp;base64,UklGRjoAAABXRUJQVlA4IC4AAACyAgCdASoCAAIALmk0mk0iIiIiIgBoSygABc6WWgAA/veff/0PP8bA//LwYAAA'
// }
export const checkWebp = async () => {
  return new Promise((resolve, reject) => {
    let img = new Image()
    img.onload = img.onerror = function() {
      resolve(img.height === 2)
    }
    img.src =
      'data:image/webp;base64,UklGRjoAAABXRUJQVlA4IC4AAACyAgCdASoCAAIALmk0mk0iIiIiIgBoSygABc6WWgAA/veff/0PP8bA//LwYAAA'
  })
}

export const treeToArray = arr => {
  var res = []
  if (Array.isArray(arr)) {
    arr.forEach(el => {
      res.push({ ...omit(el, ['layers']) })
      if (Array.isArray(el.layers)) {
        res.push(...treeToArray(el.layers))
      }
    })
  }
  return res
}

export const loadCampaign = async (store, id) => {
  var query = `query ($originProductID: String!, $store: String!){
    campaign: loadCampaign(store: $store, originProductID: $originProductID){
      platform
      originProduct
      bundledProducts
      variants
      site{
        id
        domain
      }
      artworks{
        id
        width
        height
        templates{
          layers
        }
      }
      mockups{
        id
        width
        height
        layers
      }
    }
  }`
  var headers = new Headers()
  headers.append('Content-Type', 'application/json')

  var graphql = JSON.stringify({
    query: query,
    variables: { store: store, originProductID: id }
  })
  var requestOptions = {
    method: 'POST',
    headers: headers,
    body: graphql,
    redirect: 'follow'
  }
  return new Promise((resolve, reject) => {
    fetch(`${APP_API}/query`, requestOptions)
      .then(response => response.json())
      .then(result => resolve(result.data))
      .catch(error => reject(error))
  })
}

export const checkCondition = (layer, data, layers) => {
  // var _layers = []
  // if (layers) {
  //   _layers = treeToArray(layers)
  // }
  if (layer.type !== 'Option' && !get(layer, 'visible', true)) {
    if(layer.type !== 'Label'){
      return false
    }
  }
  const condition = {
    ...{ enable: false, rules: [] },
    ...get(layer, 'condition', {})
  }
  if (
    !condition ||
    condition.enable === false ||
    condition.rules.lenght === 0
  ) {
    return true
  }
  var pass = false
  var checks = condition.rules.map(rule =>
    ((rule, data) => {
      // edit here
      if (typeof layers == 'object' && layers.length) {
        var dependLayer = layers.find(l => l.id === rule.option);
        if (dependLayer) {
          if (!checkCondition(dependLayer, data, layers)) {
            return false
          }
        }
      }
      // end edit now
      switch (rule.logic) {
        case '=':
          if (typeof rule.value === 'object') {
            return get(data[rule.option], 'key') === get(rule.value, 'key')
          } else {
            return data[rule.option] === rule.value
          }
        default:
          if (typeof rule.value === 'object') {
            return get(data[rule.option], 'key') !== get(rule.value, 'key')
          } else {
            return data[rule.option] !== rule.value
          }
      }
    })(rule, data)
  )
  if (condition.match === 'all') {
    pass = checks.every(result => result)
  } else if (condition.match === 'one') {
    pass = checks.some(result => result)
  } else if (condition.match === 'none') {
    pass = checks.every(result => !result)
  }
  return condition.action === 'show' ? pass : !pass
}

const flattenLayersTree = (layers = []) => {
  var result = []
  layers.forEach(l => {
    result.push(l)
    if (Array.isArray(l.layers)) {
      result = result.concat(flattenLayersTree(l.layers))
    }
  })
  return result
}

export const getActiveMoonColorEntry = (moonLayer, selectedId, selectedColor) => {
  const colors = get(moonLayer, 'MoonColors', []) || []
  return (selectedId && colors.find(itemColor => itemColor.id === selectedId))
    || (selectedColor && colors.find(itemColor => itemColor.color === selectedColor))
    || (moonLayer.activeMoonColorId && colors.find(itemColor => itemColor.id === moonLayer.activeMoonColorId))
    || colors[0]
}

export const isMoonColorVisible = (layer, rootLayers, data) => {
  const moonLayers = flattenLayersTree(rootLayers).filter(
    itemLayer => itemLayer.imageMoonPhase === true && Array.isArray(itemLayer.MoonColors) && itemLayer.MoonColors.length > 0
  )
  var referenced = false
  for (const moonLayer of moonLayers) {
    const colors = moonLayer.MoonColors
    const linkedHere = colors.some(
      color => Array.isArray(color.layerIds) && color.layerIds.includes(layer.id)
    )
    if (!linkedHere) continue
    referenced = true
    if (colors.length <= 1) {
      return true
    }
    const activeEntry = getActiveMoonColorEntry(
      moonLayer,
      get(data, `${moonLayer.id}.moon_color_id`),
      get(data, `${moonLayer.id}.moon_color`)
    )
    if (activeEntry && Array.isArray(activeEntry.layerIds) && activeEntry.layerIds.includes(layer.id)) {
      return true
    }
  }
  return !referenced
}

export const uploadFromBase64 = async (base64, mime = 'image/png') => {
  var file = await fetch(base64)
    .then(res => res.arrayBuffer())
    .then(buf => new File([buf], 'tmp', { type: mime }))
  var signedUrl = await getSignedUrl(file.type)
  await axios
    .put(signedUrl.url, file, {
      headers: {
        'Content-Type': file.type
      }
    })
    .catch(err => console.error(err))
  return { key: signedUrl.key }
}

export const getSignedUrl = async (mime, get = 0) => {
  var headers = new Headers()
  headers.append('Content-Type', 'application/json')
  var requestOptions = {
    method: 'GET',
    headers: headers,
    redirect: 'follow'
  }
  var signedUrl = null
  await fetch(`${AWS_API}/signedUrl?type=${mime}&get=${get}`, requestOptions)
    .then(response => response.json())
    .then(res => (signedUrl = res))
    .catch(err => console.error(err))
  return signedUrl
}

export const filterObject = (obj, key) => {
  var objClone = cloneDeep(obj)
  for (var i in objClone) {
    if (!objClone.hasOwnProperty(i)) continue
    if ((Array.isArray(key) && key.includes(i)) || key === i) {
      delete objClone[i]
    } else if (typeof objClone[i] == 'object') {
      objClone[i] = filterObject(objClone[i], key)
    }
  }
  return objClone
}

// Dữ liệu campaign do script /<store>/<id>.js (Lambda campaign) đặt vào
// window.__OMCUSTOM__.campaign. Theme có thể nạp 2 script theo thứ tự bất kỳ
// (kể cả async): script dữ liệu chạy sau thì gọi onCampaign. Resolve null khi
// Lambda báo lỗi hoặc quá thời gian chờ (script dữ liệu không tải được).
export const waitForCampaignData = (timeoutMs = 30000) => {
  const om = (window.__OMCUSTOM__ = window.__OMCUSTOM__ || {})
  if (typeof om.campaign !== 'undefined') return Promise.resolve(om.campaign)
  return new Promise(resolve => {
    const timer = setTimeout(() => resolve(null), timeoutMs)
    om.onCampaign = data => {
      clearTimeout(timer)
      resolve(data)
    }
  })
}

export const isDevMode = () => {
  return process.env.NODE_ENV === 'development'
}

export const getImageURL = (
  key,
  width = 100,
  unit = 'px',
  webp = false,
  trim = ''
) => {
  var data = {
    key,
    width,
    unit,
    webp,
    trim
  }
  if (webp && !window.__WEBP) {
    data.webp = false
  }
  return `${CDN_URL}/${btoa(JSON.stringify(data))}`
}

export const getTextOffset = (width, height, fontFamily, fontSize) => {
  var canvasWidth = width * 2 + 50
  var canvasHeight = height * 2 + 50
  var stage = new Konva.Stage({
    container: document.createElement('div'),
    width: canvasWidth,
    height: canvasHeight
  })
  Konva.pixelRatio = 1
  var layer = new Konva.Layer()
  var text = new Konva.Text({
    text: 'A1g2h3',
    fontFamily: fontFamily,
    fontSize: fontSize,
    fill: '#fff',
    verticalAlign: 'middle',
    width: width,
    height: height,
    wrap: 'none',
    ellipsis: false,
    x: 50,
    y: 50
  })
  layer.add(text)
  stage.add(layer)
  var ctx = layer.getCanvas()._canvas.getContext('2d'),
    pixels = ctx.getImageData(0, 0, canvasWidth, canvasHeight),
    l = pixels.data.length,
    i,
    bound = {
      top: null,
      left: null,
      right: null,
      bottom: null
    },
    x,
    y
  // Iterate over every pixel to find the highest
  // and where it ends on every axis ()
  for (i = 0; i < l; i += 4) {
    if (pixels.data[i + 3] !== 0) {
      x = (i / 4) % canvasWidth
      y = ~~(i / 4 / canvasWidth)
      if (bound.top === null) {
        bound.top = y
      }
      if (bound.left === null) {
        bound.left = x
      } else if (x < bound.left) {
        bound.left = x
      }
      if (bound.right === null) {
        bound.right = x
      } else if (bound.right < x) {
        bound.right = x
      }
      if (bound.bottom === null) {
        bound.bottom = y
      } else if (bound.bottom < y) {
        bound.bottom = y
      }
    }
  }
  Konva.pixelRatio = window.devicePixelRatio || 1
  var offset = {
    x: 0,
    y: (height / 2 + 50 - ((bound.bottom - bound.top) / 2 + bound.top)) * -1
  }
  return offset
}

export const rotation = (pos, deg = 0, offset = { x: 0, y: 0 }) => {
  var x = pos.x - offset.x
  var y = pos.y - offset.y
  var radian = (-deg * Math.PI) / 180
  return {
    x: x * Math.cos(radian) + y * Math.sin(radian) + offset.x,
    y: y * Math.cos(radian) - x * Math.sin(radian) + offset.y
  }
}

// Mỗi font chỉ tải 1 lần; mọi lớp chữ dùng chung font đều chờ cùng 1 promise.
// Trước đây dùng danh sách tên trong localStorage ('my_font_family_local'):
// lớp thứ 2 cùng font thấy tên đã có nên vẽ ngay bằng font dự phòng khi font
// thật vẫn đang tải -> preview gửi khách sai font / thiếu chữ.
const fontPromises = {}
const FONT_TIMEOUT = 15000

// URL file font của từng fontFamily (kết quả /font/<id>) ít khi đổi -> nhớ trong
// localStorage 7 ngày để lần sau bỏ qua 1 request /font/.
const FONT_URL_CACHE_KEY = 'oop_font_url_v1'
const FONT_URL_CACHE_TTL = 7 * 24 * 3600 * 1000
const readFontUrlCache = () => {
  try {
    return JSON.parse(localStorage.getItem(FONT_URL_CACHE_KEY)) || {}
  } catch (e) {
    return {}
  }
}
const getCachedFontUrl = fontFamily => {
  const entry = readFontUrlCache()[fontFamily]
  return entry && Date.now() - entry.t < FONT_URL_CACHE_TTL ? entry.url : null
}
const setCachedFontUrl = (fontFamily, url) => {
  try {
    const cache = readFontUrlCache()
    if (url) cache[fontFamily] = { url, t: Date.now() }
    else delete cache[fontFamily]
    localStorage.setItem(FONT_URL_CACHE_KEY, JSON.stringify(cache))
  } catch (e) {}
}

// Mở sẵn kết nối tới CDN chứa file font trong lúc chờ /font/ trả URL.
let fontPreconnected = false
const preconnectFontHost = url => {
  if (fontPreconnected) return
  fontPreconnected = true
  try {
    const link = document.createElement('link')
    link.rel = 'preconnect'
    link.href = new URL(url).origin
    link.crossOrigin = 'anonymous'
    document.head.appendChild(link)
  } catch (e) {}
}

const fetchFontUrl = fontFamily =>
  axios.get(`${AWS_API_CDN}/font/${fontFamily}`).then(res => {
    const url = typeof res.data === 'string' ? res.data : null
    setCachedFontUrl(fontFamily, url)
    return url
  })

// FontFace API: trình duyệt tải file font NGAY, không phải đợi vẽ trang như
// WebFontLoader (chèn CSS + dò bằng <span>, đo được chậm thêm 1-3s khi trang
// đang bận). Trình duyệt không hỗ trợ FontFace thì dùng WebFontLoader như cũ.
const loadFontFace = (fontFamily, url) => {
  if (!url) return Promise.resolve(false)
  preconnectFontHost(url)
  if (typeof FontFace === 'undefined' || !document.fonts) {
    return new Promise(resolve => {
      const css = `@font-face {font-family:"${fontFamily}";src:url("${url}") format("truetype");}`
      WebfontLoader.load({
        custom: {
          families: [fontFamily],
          urls: [`data:text/css;base64,${btoa(css)}`]
        },
        timeout: FONT_TIMEOUT,
        fontactive() {
          resolve(true)
        },
        fontinactive() {
          resolve(false)
        }
      })
    })
  }
  const face = new FontFace(fontFamily, `url("${url}")`)
  document.fonts.add(face)
  const timeout = new Promise(resolve => setTimeout(() => resolve(false), FONT_TIMEOUT))
  return Promise.race([face.load().then(() => true, () => false), timeout])
}

export const loadFont = fontFamily => {
  if (!fontFamily) return Promise.resolve(true)
  if (!fontPromises[fontFamily]) {
    const cachedUrl = getCachedFontUrl(fontFamily)
    fontPromises[fontFamily] = (cachedUrl
      ? loadFontFace(fontFamily, cachedUrl).then(ok =>
          // URL nhớ sẵn hỏng (font bị thay) -> hỏi lại /font/ một lần.
          ok ? ok : fetchFontUrl(fontFamily).then(url => (url && url !== cachedUrl ? loadFontFace(fontFamily, url) : false))
        )
      : fetchFontUrl(fontFamily).then(url => loadFontFace(fontFamily, url))
    ).catch(error => {
      // Lỗi mạng: lần gọi sau được tải lại thay vì nhận mãi lỗi cũ.
      delete fontPromises[fontFamily]
      throw error
    })
  }
  return fontPromises[fontFamily]
}

// Chờ mọi font đã/đang tải xong (kể cả font lỗi - không để treo).
export const waitForFonts = () =>
  Promise.all(Object.values(fontPromises).map(p => p.catch(() => false)))

// Text.vue chỉ hiện lớp chữ sau 1000ms kể từ created() (cờ `status`).
// Ghi lại lúc lớp chữ cuối cùng được tạo để chỉ chờ phần thời gian còn thiếu.
const TEXT_LAYER_SHOW_DELAY = 1100
let lastTextLayerCreatedAt = 0
export const markTextLayerCreated = () => {
  lastTextLayerCreatedAt = Date.now()
}

// Gọi ngay trước khi chụp canvas (toDataURL) làm ảnh preview gửi khách:
// chờ font, chờ các lớp chữ hiện ra, rồi vẽ lại mọi Konva stage để chữ dùng
// đúng font vừa tải. Khách đã thao tác một lúc (font đã tải, lớp chữ đã hiện)
// thì gần như không phải chờ: chỉ 1 khung hình (~16ms).
export const prepareCanvasForCapture = async () => {
  await waitForFonts()
  if (document.fonts && document.fonts.ready) {
    await document.fonts.ready.catch(() => {})
  }
  const remaining = TEXT_LAYER_SHOW_DELAY - (Date.now() - lastTextLayerCreatedAt)
  if (remaining > 0) {
    await new Promise(resolve => setTimeout(resolve, remaining))
  }
  const stages = (window.Konva && window.Konva.stages) || []
  stages.forEach(stage => stage.draw())
  await new Promise(resolve => requestAnimationFrame(() => resolve()))
}

export const customEncode = (input, password) => {
  return input;
  let encoded = '';
  for (let i = 0; i < input.length; i++) {
    const charCode = input.charCodeAt(i);
    const passwordCharCode = password.charCodeAt(i % password.length);
    encoded += String.fromCharCode(charCode + passwordCharCode);
  }
  return encoded;
}

export const customDecode = (encoded, password) => {
  // console.log('encode', encoded)
  var typedata = 'string';
  try {
    typedata = typeof JSON.parse(encoded);    
  } catch (error) {}
  if(typedata != 'string') return encoded;
  let decoded = '';
  for (let i = 0; i < encoded.length; i++) {
    const charCode = encoded.charCodeAt(i);
    const passwordCharCode = password.charCodeAt(i % password.length);
    decoded += String.fromCharCode(charCode - passwordCharCode);
  }
  return decoded;
}



// WEBPACK FOOTER //
// ./src/helper/helper.js